import * as React from "react";
import { ChromeNavGeneric } from "./ChromeNavGeneric";
import { IProps, IState } from "./ChromeNavTeamDashboard.d";

export class ChromeNavTeamDashboard extends React.Component<IProps, IState> {
  public render() {
    return (
      <ChromeNavGeneric
        label="Teammates"
        backDestination={this.props.defaultView}
        settings
        editTeam
        feedback
      />
    );
  }
}
